import classNames from "classnames"
import React from "react"

type Props = {
  className?: string
}

const RotateIcon = ({ className }: Props) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames("group", className)}
  >
    <g
      className="origin-center transition-transform duration-300 group-hover:rotate-[180deg] group-focus-visible:rotate-[180deg]"
      style={{ transformBox: "fill-box" }}
    >
      <path
        d="M11.541 5.49992L13.3743 3.66659L11.541 1.83325"
        stroke="#222222"
        strokeWidth="1.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4583 16.5L8.625 18.3333L10.4583 20.1667"
        stroke="#222222"
        strokeWidth="1.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.2015 5.84009C17.5169 7.16559 18.3337 8.98517 18.3337 11C18.3337 15.0498 15.0502 18.3333 11.0003 18.3333C10.2798 18.3333 9.5859 18.2252 8.92773 18.0318"
        stroke="#222222"
        strokeWidth="1.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.73218 16.0986C4.45435 14.7786 3.66602 12.9819 3.66602 11.0001C3.66602 6.95025 6.94952 3.66675 10.9993 3.66675C11.7198 3.66675 12.4138 3.77491 13.0719 3.96833"
        stroke="#222222"
        strokeWidth="1.375"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
)

export default RotateIcon
